// The validation the Vue 2 app did with vee-validate, as Vuetify 3 rule
// functions: a rule answers true, or the message to show under the field.
//
// Only the four rules the app ever used, with vee-validate's own Estonian
// messages ('required' has always had its own). Where a vee-validate message
// named the field, the name is passed in — the same name the ValidationProvider
// carried, which is what the old message printed.
//
// Behaviour kept from vee-validate 3: every rule but `required` passes an empty
// value (so an optional e-mail may stay empty), `required` takes `false` as an
// answer (an unticked checkbox is filled in), and whitespace is not a value.

const isEmpty = value =>
  value === undefined ||
  value === null ||
  (Array.isArray(value) && value.length === 0) ||
  (typeof value !== 'boolean' && !String(value).trim().length)

export const required = value => !isEmpty(value) || 'Väli on kohustuslik'

// vee-validate 3's own pattern.
const EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const email = (field = 'email') => value =>
  isEmpty(value) || EMAIL.test(String(value).trim()) || `${field} peab olema e-maili aadress`

export const min = (length, field) => value =>
  isEmpty(value) || String(value).length >= length || `${field} peab olema vähemalt ${length} tähemärki pikk`

// `other` is read when the rule runs, so it follows the field it is compared to.
export const confirmed = (other, field) => value =>
  isEmpty(value) || value === other() || `${field} on kontrollist erinev`

export default { required, email, min, confirmed }
